import React from "react";
import { Navigate } from "react-router-dom";

import Login from "../pages/Authentication/Login";
import Register from "../pages/Authentication/Register";
import Logout from "../pages/Authentication/Logout";

//Dashboard
import Dashboard from "../pages/Dashboard";
//Monitoring

import Storage from "../pages/Storage";
import UserProfile from "../pages/Profile";

//Report
import TemplateReport from "../pages/Report/TemplateReport";
import Template from "../pages/Report/TemplateReport/Template";

import Templates from "../pages/Template";

import DashboardTemplate from "../pages/Setting/DashboardTemplate";

import QRLanding from "../pages/Landing/qr";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/report", component: <TemplateReport /> },
  { path: "/report-template/:rptTemplateId", component: <Template /> },
  { path: "/templates", component: <Templates /> },
  { path: "/dashboard-templates", component: <DashboardTemplate /> },
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },
  { path: "/qr/:taskId", component: <QRLanding /> },
];

export { authProtectedRoutes, publicRoutes };
